import { ResourceInIncident } from '../../hooks/resourceInIncidentHooks';
import { RESOURCE_STATUSES } from '../constants/resourceConstants';

/**
 * Filters resources to get checked-in resources A resource is considered
 * checked-in if it has one of the checked-in statuses Note: IN_TRANSIT is
 * excluded from this filter even though it's in CHECKED_IN_STATUSES
 *
 * @param resources - Array of resources to filter
 * @returns Array of checked-in resources
 */
export const filterCheckedInResources = (
  resources: ResourceInIncident[]
): ResourceInIncident[] => {
  const checkedInStatuses = [
    RESOURCE_STATUSES.AVAILABLE,
    RESOURCE_STATUSES.ASSIGNED,
    RESOURCE_STATUSES.OS_REST,
    RESOURCE_STATUSES.OS_PERSONNEL,
    RESOURCE_STATUSES.OS_MECHANICAL,
    RESOURCE_STATUSES.ETR,
  ];

  return resources.filter((r) =>
    checkedInStatuses.includes(r.current_status as any)
  );
};

/**
 * Filters resources to get checked-out resources A resource is considered
 * checked-out if it has a checkout_datetime OR has checked_out or in_process
 * status
 *
 * @param resources - Array of resources to filter
 * @returns Array of checked-out resources
 */
export const filterCheckedOutResources = (
  resources: ResourceInIncident[]
): ResourceInIncident[] => {
  return resources.filter(
    (r) =>
      r.checkout_datetime ||
      r.current_status === RESOURCE_STATUSES.CHECKED_OUT ||
      r.current_status === RESOURCE_STATUSES.IN_PROCESS
  );
};

/**
 * Applies status filter to resources
 *
 * @param resources - Array of resources to filter
 * @param status - Status to filter by, or 'all' for no filtering
 * @returns Filtered array of resources
 */
export const filterResourcesByStatus = (
  resources: ResourceInIncident[],
  status: string
): ResourceInIncident[] => {
  if (status === 'all') {
    return resources;
  }

  return resources.filter((r) => r.current_status === status);
};

/**
 * Filters checked-out resources by specific status
 *
 * @param resources - Array of checked-out resources
 * @param status - Status to filter by ('all', 'checked_out', 'in_process')
 * @returns Filtered array of resources
 */
export const filterCheckedOutResourcesByStatus = (
  resources: ResourceInIncident[],
  status: string
): ResourceInIncident[] => {
  if (status === 'all') {
    return resources;
  }

  if (status === 'checked_out') {
    return resources.filter(
      (r) => r.current_status === RESOURCE_STATUSES.CHECKED_OUT
    );
  }

  if (status === 'in_process') {
    return resources.filter(
      (r) => r.current_status === RESOURCE_STATUSES.IN_PROCESS
    );
  }

  return resources;
};
